import { Tag, Space, Typography } from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";

const { Text } = Typography;

const formatCost = (val) =>
  val == null ? null : `$${Number(val).toFixed(7).replace(/0+$/, "0")}`;

const PRE_STYLE = {
  marginTop: 8,
  padding: 10,
  borderRadius: 6,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  fontSize: 12,
  lineHeight: 1.5,
  maxHeight: 160,
  overflowY: "auto",
  margin: 0,
};

const SmokeTestResult = ({ result }) => {
  if (!result) return null;

  const {
    success,
    response_text,
    error_message,
    latency_ms,
    tokens_used,
    estimated_cost,
    provider_key,
    model_id,
  } = result;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Space wrap size={[6, 6]}>
        {success ? (
          <Tag icon={<CheckCircleFilled />} color="success">Success</Tag>
        ) : (
          <Tag icon={<CloseCircleFilled />} color="error">Failed</Tag>
        )}
        {latency_ms != null && (
          <Tag color="blue">{(latency_ms / 1000).toFixed(2)}s</Tag>
        )}
        {tokens_used?.total_tokens != null && (
          <Tag color="purple">
            {tokens_used.total_tokens.toLocaleString()} tokens
            {" "}
            <span style={{ fontSize: 11, opacity: 0.75 }}>
              ({tokens_used.prompt_tokens}↑ + {tokens_used.completion_tokens}↓)
            </span>
          </Tag>
        )}
        {estimated_cost != null && (
          <Tag color="gold">{formatCost(estimated_cost)}</Tag>
        )}
        {(provider_key || model_id) && (
          <Tag color="default">
            {provider_key}
            {model_id ? ` / ${model_id}` : ""}
          </Tag>
        )}
      </Space>

      {error_message && (
        <div
          style={{
            padding: 10,
            background: "#fff2f0",
            border: "1px solid #ffccc7",
            borderRadius: 6,
          }}
        >
          <Text type="danger" style={{ fontSize: 12 }}>{error_message}</Text>
        </div>
      )}

      {response_text && (
        <>
          <Text
            strong
            style={{
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: 0.5,
              color: "#888",
            }}
          >
            Response
          </Text>
          <pre
            style={{
              ...PRE_STYLE,
              background: success ? "#f6ffed" : "#f5f5f5",
              border: success ? "1px solid #b7eb8f" : "1px solid #d9d9d9",
            }}
          >
            {response_text}
          </pre>
        </>
      )}
    </div>
  );
};

export default SmokeTestResult;
